import { Box, IconButton } from 'ui';
import { Circle } from 'ui/icons';

export const CaptureButton = ({
  onClick,
  disabled,
  ariaLabel,
}: {
  onClick: () => void;
  disabled: boolean;
  ariaLabel?: string;
}) => {
  return (
    <Box
      sx={{
        border: '3px solid white',
        borderRadius: '50%',
        cursor: 'pointer',
        height: 70,
        p: 0.25,
        width: 70,
      }}
    >
      <IconButton onClick={onClick} disabled={disabled} aria-label={ariaLabel}>
        <Circle sx={{ color: 'white', height: '100%', width: '100%' }} />
      </IconButton>
    </Box>
  );
};
